import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { useDispatch } from "react-redux";
// Icons
import { Plus, ArrowLeft, SearchIcon, X } from "lucide-react";
import TableContainer from "Common/TableContainer";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";

import {
  addBurdanFarmerReducer,
  deleteBurdanFarmerReducer,
  getBurdanFarmerReducer,
  updateBurdanFarmerReducer,
} from "slices/Burdanfarmers/reducer";
import BurdanFarmerColumn from "Common/Components/ColumnData/BurdanFarmer";
import LoadFormModal from "Common/Components/LoadFormModal/LoadFormModal";
import InvoiceWithInput from "Common/Components/PDFRender";

const Burdenfarmers = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isEdit, setIsedit] = useState<boolean>(false);
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [commitment_idList, setcommitment_idList] = useState<any>();
  const [SearchValueCommit, setSearchValueCommit] = useState<any>();
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const [selectedCommitment, setSelectedCommitment] = useState<any>(null);
  const [isLoadingBtn, setisLoadingBtn] = useState<any>();
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [Datevalues, setDatevaluesValues] = useState<DateObject | null>(
    new DateObject({ calendar: persian }).setLocale(persian_fa)
  );
  const [DataID, setDataID] = useState<any>();
  const [dataFactoryID, setDataFactoryID] = useState<any>();
  const [dataFactoryList, setdataFactoryList] = useState<any>([]);
  const [isEditCrepID, setisEditCrepID] = useState<any>([]);
  const cropYearID = localStorage.getItem("crop_year_id");
  const [UserFullName, setUserFullName] = useState<any>();
  const [exportPdf, setExportPdf] = useState<any>();
  const [userinfoAllData, setuserinfoAllData] = useState<any>();
  const [LoadFarmer, setLoadFarmer] = useState<any>();
  const [mainIDFarmer, setMainIDfarmer] = useState<any>(null);
  const dispatch = useDispatch<any>();
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  const sortLabels: any = {
    farmer_name: "نام کشاورز",
    dirt_weight: "وزن خاک (کیلوگرم)",
    total_weight: " وزن کل (کیلوگرم)",
    load_number: " شماره بارنامه ",
    date: "تاریخ",
  };
  const [selectedFarmerInfo, setSelectedFarmerInfo] = useState<any>({
    amount_of_land: "",
    village_name: "",
    date_set: "",
  });
  useEffect(() => {
    const getFarmerInfo = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `https://api.havirkesht.ir/commitment/${Number(mainIDFarmer)}`, // توجه: coomitID به commitID تغییر کرد
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        if (res?.data.amount_of_land) {
          setIsLoading(false);
          setSelectedFarmerInfo({
            amount_of_land: res?.data.amount_of_land || "", // اگر null بود، خالی برگردان
            village_name: res?.data?.village_name || "",
            date_set: res?.data?.date_set || "",
          });
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching farmer info:", error);
      }
    };
    getFarmerInfo();
  }, [mainIDFarmer]);

  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${cropYearID}`;
        if (SearchValueCommit && SearchValueCommit.trim() !== "") {
          url += `&search=${encodeURIComponent(SearchValueCommit.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setcommitment_idList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [SearchValueCommit]);
  useEffect(() => {
    if (isEdit && eventData) {
      validation.setValues({
        ...eventData,
        date: eventData.date,
        farmer_id: eventData.farmer_id,
        factory_id: eventData.factory_id,
      });
    }
  }, [isEdit, eventData]);

  const handleUpdateDataClick = async (ele: any) => {
    setIsedit(true);
    setShow(true);
    setisEditCrepID(ele?.crop_year_id);
    await Promise.all([
      setEventData(ele),
      setSelectedCommitment({
        value: ele.farmer_id,
        label: ele.farmer_name,
      }),
      setDataID(ele.id),
      setDataFactoryID(ele.factory_id),
      setDatevaluesValues(ele.date),
    ]);

    // سپس مقادیر فرم را تنظیم کنید
    validation.setValues({
      ...ele,
      date: ele.date,
      farmer_id: ele.farmer_id,
      factory_id: ele.factory_id,
    });
  };

  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize);
    setCurrentPage(newPage);
    fetchData(newPage, newSize);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  useEffect(() => {
    fetchData(currentPage, selectedNumber || 10);
  }, [currentPage, size, reload, searchValue, sortState]);

  const fetchData = async (page: number, size: number) => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      // ساخت پارامترهای سورت
      let sortParams = "";
      let sortOrder = "";

      if (sortState) {
        if (sortState.step === 2) {
          sortParams = "created_at";
          sortOrder = "desc";
        } else {
          // step 0 یا 1
          sortParams = sortState.name || "updated_at";
          sortOrder = sortState.order === "asc" ? "asc" : "desc";
        }
      }

      const res = await dispatch(
        getBurdanFarmerReducer({
          url: `https://api.havirkesht.ir/farmers_load/?sort_by=${sortParams}&sort_order=${sortOrder}`,
          page: page,
          size: size,
          searchValue: searchValue?.trim() || null,
          crop_year_id: cropYearID,
        })
      );

      if (!res.payload) {
        throw new Error("پاسخ سرور نامعتبر است");
      }

      const items = res.payload.data.items;
      const total = Number(res.payload.data.total) || 0;
      const pages = Number(res.payload.data.pages) || 1;
      console.log(items);

      setData(items);
      setalldata(total);
      setTotalPages(pages);
    } catch (error: any) {
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });

      setErrorMessage(
        error.response?.status === 404
          ? "منبع یافت نشد"
          : error.response?.data?.message || "خطا در دریافت داده‌ها"
      );

      setData([]);
      setalldata(0);
      setTotalPages(1);
      toast.error("خطا در بارگذاری پرداخت‌ها");
    } finally {
      setIsLoading(false);
    }
  };
  const fetchReport = async (farmer_ID: any): Promise<void> => {
    // تعریف ثابت‌ها
    const API_BASE_URL = "https://api.havirkesht.ir";
    const AUTH_TOKEN = localStorage.getItem("app_atkey");

    const headers = {
      Authorization: `Bearer ${AUTH_TOKEN}`,
    };
    try {
      // 1. دریافت userID
      const userResponse = await axios.get<any>(
        `${API_BASE_URL}/farmer/farmer-id-to-user-id/${farmer_ID}`
      );
      const userID = userResponse?.data?.user_id;
      const [loadResponse, commitmentResponse, userinfoData] =
        await Promise.all([
          axios.get(`${API_BASE_URL}/farmers_load/by-user/${userID}`, {
            headers,
          }),
          axios.get<any[]>(`${API_BASE_URL}/commitment/by-user/${userID}`, {
            headers,
          }),
          axios.get(`${API_BASE_URL}/users/${userID}`, {
            headers,
          }),
        ]);
      // 3. تنظیم state ها
      setUserFullName(commitmentResponse.data[0]);
      setLoadFarmer(loadResponse.data);
      setuserinfoAllData(userinfoData.data);
      setExportPdf(true);
      setTimeout(() => {
        setLoadFarmer([]);
        setUserFullName(false);
        setExportPdf(false);
      }, 1000);
    } catch (err) {
      alert(
        "خطا در دریافت اطلاعات صورتحساب کشاورز اطلاعات این کشاورز در سیستم ثبت نشده است"
      );
      console.error("Error fetching report:", err);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataFactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await dispatch(deleteBurdanFarmerReducer(eventData));
        if (res.payload.dataID) {
          Swal.fire({
            title: "حذف بار",
            text: "عملیات حذف با موفقیت انجام شد",
            icon: "success",
          });
          setreload(!reload);
        } else {
          Swal.fire({
            title: "حذف بار",
            text: "مشکلی در حذف به وجود امده است",
            icon: "error",
          });
        }
        setDeleteModal(false);
        setEventData(null);
      } catch (error) {
        toast.error("مشکل در حذف داده ");
      }
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      farmer_id: null,
      // factory_id:  dataFactoryID || null,
      date: "string",
      load_number: "",
      driver_name: "",
      phone_number: "",
      total_weight: null,
      dirt_weight: null,
      pest_weight: null,
      pure_weight: null,
      sugar_beet_polarity: 0,
      price_per_kilo: null,
      rent_help: null,
      transportation_cost: null,
      quota_sugar_price: null,
      quota_pulp_price: null,
      pure_payable: null,
      id: null,
    },
    validationSchema: Yup.object({
      farmer_id: Yup.number().required("کشاورز الزامی است"),
      // factory_id: Yup.number().required("شناسه کارخانه الزامی است"),
      date: Yup.string().required("تاریخ الزامی است"),
      load_number: Yup.string().required("شماره بار الزامی است"),
      driver_name: Yup.string().required("نام راننده الزامی است"),
      total_weight: Yup.number()
        .required("وزن کل الزامی است")
        .min(1, "وزن باید بیشتر از صفر باشد"),
      dirt_weight: Yup.number()
        .min(0, "وزن خاک نمی‌تواند منفی باشد")
        .required("وزن خاک الزامی است"),
      pest_weight: Yup.number()
        .min(0, "وزن افت نمی‌تواند منفی باشد")
        .required("وزن افت الزامی است"),
      sugar_beet_polarity: Yup.number()
        .min(0, "عیار نمی‌تواند منفی باشد")
        .max(100, "عیار نمی‌تواند بیشتر از ۱۰۰ باشد")
        .required("عیار چغندر الزامی است"),
      price_per_kilo: Yup.number()
        .min(0, "قیمت نمی‌تواند منفی باشد")
        .required("قیمت هر کیلو الزامی است"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        setisLoadingBtn(true);
        const transportData = {
          ...values,
          date: Datevalues,
          farmer_id: selectedCommitment?.value || values.farmer_id,
          dataID: DataID,
          factory_id: dataFactoryID,
          crop_year_id: isEditCrepID,
        };

        if (isEdit) {
          console.log(transportData, "transportData");
          const res = await dispatch(updateBurdanFarmerReducer(transportData));
          if (res.payload) {
            Swal.fire({
              title: "بروزرسانی بار  موفق",
              text: "بار  با  موفقیت بروزرسانی شد",
              icon: "success",
            });
            resetFormFunCtion();
            setShow(false);
            setreload(!reload);
            setSelectedCommitment(null);
            setDataFactoryID(null);
            setDataID(null);
            setIsedit(false);
            setDatevaluesValues(
              new DateObject({ calendar: persian }).setLocale(persian_fa)
            );
          }
          try {
            await axios.post(
              `https://api.havirkesht.ir/sms/farmer-load-rent-help-notification/${values.id}`
            );
          } catch (error) {
            console.log(error, "❌");
          }
        } else {
          if (!dataFactoryID || !dataFactoryID || !cropYearID) {
            setShow(true);
            return toast.error("لطفا فیلد های الزامی را پر کنید");
          }
          const transportData = {
            ...values,
            date: Datevalues ? Datevalues.format("YYYY/MM/DD") : null,
            farmer_id: selectedCommitment.value || values.farmer_id,
            dataID: DataID,
            factory_id: dataFactoryID,
            crop_year_id: cropYearID,
          };
          const res = await dispatch(addBurdanFarmerReducer(transportData));
          await axios.post(
            `https://api.havirkesht.ir/sms/farmer-load-notification/${Number(
              res.payload.id
            )}`,
            null, // or your request body if needed
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
              },
            }
          );
          if (res.payload.status) {
                Swal.fire({
              title: "خطا در ثبت بار  ",
              text: "بار جدید با خطا مواجه شد",
              icon: "error",
            });
            resetFormFunCtion();
          } else {
            Swal.fire({
              title: "ثبت بار  موفق",
              text: "بار جدید با موفقیت ثبت شد",
              icon: "success",
            });
          }
          resetFormFunCtion();
          setDatevaluesValues(
            new DateObject({ calendar: persian }).setLocale(persian_fa)
          );
        }
      } catch (error: any) {
        const backendMessage = error?.response?.data?.detail;
        console.log(error, "error");

        if (backendMessage === "Duplicate load_number for this factory and crop year") {
          return Swal.fire(
            "خطا",
            "بار با این شماره قبلاً برای این کارخانه در این سال زراعی ثبت شده است",
            "error"
          );
        }

        if (error?.response?.status === 400) {
          return Swal.fire(
            "خطا",
            "کشاورز با سال زراعی انتخاب شده پیدا نشده",
            "error"
          );
        }

        resetFormFunCtion();
        console.error("Submission error:", error);
        toast.error(error.response?.data?.message || "خطا در ارسال اطلاعات");
      }
      finally {
        setisLoadingBtn(false);
        setSubmitting(false);
      }
    },
  });
  function resetFormFunCtion() {
    validation.resetForm();
    setShow(false);
    setreload(!reload);
    setDataFactoryID(null);
    setSelectedCommitment(null); // اضافه کردن این خط
    setIsedit(false);
    setMainIDfarmer(null);
  }

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setMainIDfarmer(null);
      setIsedit(false);
      validation.resetForm();
      setSelectedCommitment(null);
      setDatevaluesValues(
        new DateObject({ calendar: persian }).setLocale(persian_fa)
      );
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        // اگر روی همان ستون کلیک شد
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name: "created_at", order: "desc", step: 2 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        return { name, order: "desc", step: 0 };
      }
    });
    setreload(!reload);
  };
  const savaDataToPDF = (data: any) => {
    fetchReport(data.farmer_id);
  };
  const columns = BurdanFarmerColumn({
    handleUpdateDataClick,
    onClickDelete,
    columnName,
    savaDataToPDF,
  });

  const formatNumber = (num: any) => {
    if (num == null || num === undefined || num === "") return "";
    const numStr = num?.toString()?.replace(/,/g, "");
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum?.replace(/,/g, "");
  };
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت بار " title=" هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {errorMessage && (
        <div className="text-red-500 text-center my-4">{errorMessage}</div>
      )}
      <div className="card" id="employeeTable">
        <div className="card-body">
          <div className="flex items-center flex-col md:flex-row gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع بارها (
              <b className="total-Employs">{alldata?.toString()}</b>)
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute inset-y-0 left-2 flex items-center text-gray-400">
                    <SearchIcon />
                  </span>
                </div>
              </label>
            </h6>
            <div className="w-full sm:w-auto">
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <div className="shrink-0">
              <button
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl"> ثبت بار جدید </span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </button>
            </div>
          </div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                }`}
            </div>
          )}

          {isLoading ? (
            <LoadingCounter count={15} text="در حال بارگذاری..." />
          ) : data && data.length > 0 ? (
            <>
              <TableContainer
                isPagination={false}
                columns={columns}
                isGlobalFilter={false}
                data={data}
                customnumberfortable={10}
                customPageSize={selectedNumber}
                divclassName="-mx-5 overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
                tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
              />
              <PaginationTest
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </>
          ) : (
            <LoadingCounter
              count={0}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      {/* Modal */}
      <LoadFormModal
        show={show}
        isEdit={isEdit}
        onHide={toggle}
        onSubmit={validation.handleSubmit}
        validation={validation}
        selectedCommitment={selectedCommitment}
        setSelectedCommitment={setSelectedCommitment}
        setMainIDfarmer={setMainIDfarmer}
        setSearchValueCommit={setSearchValueCommit}
        commitment_idList={commitment_idList}
        mainIDFarmer={mainIDFarmer}
        isLoading={isLoading}
        selectedFarmerInfo={selectedFarmerInfo}
        dataFactoryID={dataFactoryID}
        setDataFactoryID={setDataFactoryID}
        dataFactoryList={dataFactoryList}
        Datevalues={Datevalues}
        setDatevaluesValues={setDatevaluesValues}
        isLoadingBtn={isLoadingBtn}
        isEditCrepID={isEditCrepID}
        YearCoptSelect={YearCoptSelect}
        formatNumber={formatNumber}
        parseFormattedNumber={parseFormattedNumber}
      />
      <InvoiceWithInput
        userInfo={UserFullName}
        exportPdfFromProp={exportPdf}
        userinfoData={userinfoAllData}
        dataLoad={LoadFarmer}
        dontShowData={true}
        dontshowSummey={true}
      />
    </React.Fragment>
  );
};

export default Burdenfarmers;
